import React from 'react';
import ExpansionPanelMaterial from '@material-ui/core/ExpansionPanel';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import Typography from '@material-ui/core/Typography';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import classNames from 'classnames';

import { components, } from 'styles';

type Props = {
    id: number;
    children: any;
    expandedPanelId: number | null;
    handleChange: Function;
    header: string;
    noBorder?: boolean;
    disableTitleMargin?: boolean;
};

const ExpansionPanel: React.FC<Props> = ({
    id,
    children,
    expandedPanelId,
    handleChange,
    header,
    noBorder,
    disableTitleMargin,
}) => {
    const { expandIcon, } = components.makeExpandIconStyles();
    const expansionPanelClasses = components.makeExpansionPanelStyles({ noBorder });
    const expansionPanelDetailsClasses = components.makeExpansionPanelDetailsStyles();
    const expansionPanelSummaryClasses = components.makeExpansionPanelSummaryStyles({ disableTitleMargin, });
    const expansionPanelTypographyClasses = components.makeExpansionPanelTypographyStyles();
    const expandedPanelHasEqualId = expandedPanelId === id;

    return (
        <ExpansionPanelMaterial classes={expansionPanelClasses}
                                elevation={0}
                                expanded={expandedPanelHasEqualId}
                                onChange={handleChange(id)}
                                square>
            <ExpansionPanelSummary classes={expansionPanelSummaryClasses}>
                <ExpandMoreIcon
                    className={classNames(expandIcon, {
                        expand: expandedPanelHasEqualId,
                    })}
                />
                <Typography
                    classes={expansionPanelTypographyClasses}
                    dangerouslySetInnerHTML={{ __html: header }}
                />
            </ExpansionPanelSummary>
            <ExpansionPanelDetails classes={expansionPanelDetailsClasses}>
                {children}
            </ExpansionPanelDetails>
        </ExpansionPanelMaterial>
    );
};

export default ExpansionPanel;
